<template>
    <Modal :id="'cpm-catalaog-releases-pro_agency'" :loading="loading" @cancelled="onCancel">
        <template slot="header">{{ $t('pro_agency_delivery') }}</template>

        <template slot="body">
            <div class="form-group">
                <Dropdown :options="api_accountsTV" :id="'api_account'" class="m2"
                    :selected="api_accountsTV.find(e => e.value == api_account)" :placeholder="$t('api_account')"
                    @selectedChange="e => onDropdownChange('api_account', e)" box :listHeight="250"></Dropdown>
                <Dropdown :options="labelsTV" :id="'pro_agency_account'" class="m2"
                    :selected="labelsTV.find(e => e.value == label_filter_id)" :placeholder="$t('pro_agency_account')"
                    @selectedChange="e => onDropdownChange('label_filter_id', e)" box :listHeight="250"></Dropdown>
                <div class="checkbox-container">
                    <div style="height:20px;" class="dt-checkbox-control">
                        <div style="margin-top:5px;margin-top: 3px;margin-right:0px;margin-left: 0px;"
                            class="dt-checkbox v2 s1">
                            <input tabindex="-1" type="checkbox" @change="changeCheckbox" v-model="all_undelivered"
                                name="all_undelivered" id="all_undelivered" class="checkbox-input" />
                            <div tabindex="0" class="checkmark"></div>
                        </div>
                        <div style="padding-left:5px" class="dt-checkbox-label">{{ $t('all_undelivered') }}</div>
                    </div>
                </div>


                <TextField v-if="!all_undelivered" type="date" v-bind="textFieldConfig" @validated="onValidation" required
                    id="release_start" class="m1" :placeholder="$t('release_start')" :value="release_start"
                    autocomplete="off" @valuechanged="onTextFieldValueChange" />
                <TextField v-if="!all_undelivered" type="date" v-bind="textFieldConfig" @validated="onValidation" required
                    id="release_end" class="m1" :placeholder="$t('release_end')" :value="release_end" autocomplete="off"
                    @valuechanged="onTextFieldValueChange" />
                <Dropdown :options="packageSizeTV" :id="'package_size'" class="m2"
                    :selected="packageSizeTV.find(e => e.value == package_size)" :placeholder="$t('package_size')"
                    @selectedChange="e => onDropdownChange('package_size', e)" box :listHeight="250"></Dropdown>



            </div>
        </template>
        <template slot="options">

            <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
            <button class="dt-button s6 v1" :class="{ disabled: !isFormValid }" :disabled="!isFormValid"
                @click.stop="onContinue">
                {{$t('continue')}}
            </button>
        </template>
    </Modal>
</template>
  
<script>



export default {
    data: function () {
        return {
            textFieldConfig: {
                height: 42,
                showEditIconOnHover: false,
                box: true,
                showValidationIcons: true,
                immediateValidation: true,
            },
            statuses: [],
            all_undelivered: false,
            api_account: '',
            label_ids: '',
            label_filter_id: '',
            release_start: '',
            release_end: null,
            package_size: 25,
            loading: false,
            labels: [],
            validationResult: {},
            proAgencyData: null
        };
    },
    mounted: async function () {
        const proAgencyData = await window.HttpClient.get('/label.pl', {
            section: "plugin",
            action: "pro_agency_delivery_modal_data"
        });
        console.log("WERE", proAgencyData);
        this.proAgencyData = proAgencyData.data;
    },
    computed: {
        isFormValid: function () {
            return this.all_undelivered ? true : Object.values(this.validationResult).every(e => e.valid);
        },
        labelsTV: function () {
            return this.proAgencyData?.pro_agency_accounts[0]?.labels.map(e => {
                return {
                    text: e.label_name,
                    value: e.label_id
                };
            }).filter(e => e.text != "") || [];
        },
        api_accountsTV: function () {
            return this.proAgencyData?.api_accounts?.map(e => {
                return {
                    text: e.account,
                    value: e.account
                };
            }) || [];
        },
        packageSizeTV: function () {
            return [{ text: 25, value: 25 }, { text: 50, value: 50 }, { text: 100, value: 100 }, { text: 250, value: 250 }, { text: 'All', value: 'all' }]
        },


    },
    methods: {
        onValidation: function (name, value) {
            this.$set(this.validationResult, name, value);
            console.log(this.validationResult);
        },
        onTextFieldValueChange: function (key, value) {
            this[key] = value
        },
        onCancel: function () {
            this.$emit("cancelled", true);
        },
        onContinue: function () {
            if (this.all_undelivered) {
                const url = window.HttpClient.getBaseUrl() + "/" + this.proAgencyData.v2_url_hash_part + "/pro-agency-data-transfer?api_account=" + this.api_account + '&label_ids=' + this.proAgencyData.pro_agency_accounts[0].label_ids + '&label_filter_id=' + this.label_filter_id + '&limit=' + this.package_size;
                window.open(url, '_blank');
            }
            else {
                const url = window.HttpClient.getBaseUrl() + "/" + this.proAgencyData.v2_url_hash_part + "/pro-agency-data-transfer?api_account=" + this.api_account + '&label_ids=' + this.proAgencyData.pro_agency_accounts[0].label_ids + '&label_filter_id=' + this.label_filter_id + '&limit=' + this.package_size + '&start=' + this.release_start + '&end=' + this.release_end;
                window.open(url, '_blank');
            }


        },
        changeCheckbox(e) {
            console.log('/////',e)
            this.all_undelivered = !this.all_undelivered

        },
        onDropdownChange: function (name, value) {

            this[name] = value.value


        },

        //MARK: Methods
    }
};


</script>
  
